import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import cx from 'classnames';
import { match } from 'ts-pattern';

import { BedrockAgentType } from '@cloud-wave/neon-common-lib';

import Icon from 'lib/common/components/Icon';
import { IconSizeConstraints } from 'lib/common/components/Icon/Icon';
import Text from 'lib/common/components/Text';

import { useAIContext } from '../../../Context';
import { getBedrockAgentForAction } from '../constants/IQActionItems';
import { ActionsMenuItemProps } from './types/ActionsMenuItemProps';

import styles from './actions-menu-item.module.scss';

export default function ActionsMenuItem({ item, displayMode, disabled }: ActionsMenuItemProps) {
  const {
    state: { iqInput },
    actions: { selectAction, think },
  } = useAIContext();
  const displayModeLower = displayMode.toLowerCase();

  const { title, iconProps, actionID } = item;
  const icon = iconProps[displayMode];
  const titleText = title[displayMode];

  const onClick = () => {
    selectAction(actionID);

    const agent = getBedrockAgentForAction(actionID);
    // actions with no secondary menu
    match(agent)
      .with(BedrockAgentType.AI_CORRECT, BedrockAgentType.AI_EXTRACT, (bedrockAgent) => {
        think({ body: { userText: iqInput || '' }, action: bedrockAgent });
      })
      .otherwise(() => {
        //Do nothing
      });
  };

  return (
    <button
      className={cx(styles['actions-menu-item'], styles[`actions-menu-item--${displayModeLower}`])}
      onClick={onClick}
      disabled={disabled}
      aria-label={titleText}
    >
      <div
        className={cx(
          styles[`actions-menu-item__content-container`],
          styles[`actions-menu-item--${displayModeLower}__content-container`]
        )}
      >
        <div className={styles['actions-menu-item__icon']}>
          <Icon icon={icon.iconType} size={icon.size} color={icon.color} onlyConstrain={IconSizeConstraints.HEIGHT} />
        </div>
        <div
          className={cx(
            styles['actions-menu-item__content'],
            styles[`actions-menu-item--${displayModeLower}__content`]
          )}
        >
          <div className={styles['actions-menu-item__text']}>
            <Text className={styles[`actions-menu-item__text__title`]}>{titleText}</Text>
          </div>
          {item.childMenu && (
            <div
              className={cx(
                styles['actions-menu-item__content__arrow-container'],
                styles[`actions-menu-item--${displayModeLower}__content__arrow-container`]
              )}
            >
              <Icon icon={faChevronRight} size={15} color={icon.color} />
            </div>
          )}
        </div>
      </div>
    </button>
  );
}
